import request from '@/services/request';
import Api from '@/api/api';

export const getContent = ({ page, limit, type }) => {
  const path = `/admin/content/${type}`;
  return request.get(path, { params: { page, limit } });
};

export const featureContent = id => request.post(`/admin/content/${id}/feature`);
export const unfeatureContent = id => request.post(`/admin/content/${id}/unfeature`);
export const hideContent = id => request.post(`/admin/content/${id}/hide`);
export const deleteContent = id => request.delete(`/admin/content/${id}`);

export const getSections = () => request.get('/admin/sections');
export const updateSection = (id, data) => request.put(`/admin/sections/${id}`, data);
export const createSection = data => request.post('/admin/sections', data);
export const deleteSection = id => request.delete(`/admin/sections/${id}`);

class AdminApi extends Api {
  constructor() {
    super('admin');
  }

  impersonate(username) {
    return this.request.post(this.getURL(`impersonate/${username}`));
  }
}

export default new AdminApi();
